module.exports = __webpack_public_path__ + "img/Flag_of_the_Cocos_(Keeling)_Islands.288f78a8.svg";